import { CheckIcon, CircleArrowRightIcon, CircleIcon, WorkflowIcon } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

import type { SidebarItemState } from '@/pages/company-drawer/company-overview/set-irq-modal/types'

export const ITEM_ICON_BY_STATE: Record<SidebarItemState, LucideIcon> = {
  active: CircleArrowRightIcon,
  visited: CheckIcon,
  idle: CircleIcon,
  conditional: WorkflowIcon,
}
